"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var styles = function styles(theme) {
  return {
    fullScreenVariant: {
      zIndex: theme.zIndex.snackbar,
      position: 'fixed',
      display: 'flex',
      flexDirection: 'column-reverse',
      left: 0,
      bottom: 0
    },
    wizardVariant: (0, _defineProperty2["default"])({
      zIndex: theme.zIndex.snackbar,
      position: 'absolute',
      display: 'flex',
      flexDirection: 'column-reverse',
      right: '-24px',
      padding: '0 16px',
      marginLeft: 'auto',
      marginRight: 'auto',
      bottom: '-8px',
      width: '100%',
      maxWidth: '666px'
    }, theme.breakpoints.down('md'), {
      top: '16px',
      bottom: 'auto',
      left: 0,
      right: 0
    }),
    pageVariant: {
      zIndex: theme.zIndex.snackbar,
      position: 'absolute',
      display: 'flex',
      flexDirection: 'column-reverse',
      left: 0,
      right: 0,
      bottom: 0
    }
  };
};

var NotificationBar =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(NotificationBar, _PureComponent);

  function NotificationBar() {
    (0, _classCallCheck2["default"])(this, NotificationBar);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(NotificationBar).apply(this, arguments));
  }

  (0, _createClass2["default"])(NotificationBar, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          variant = _this$props.variant,
          classes = _this$props.classes;
      var snackBarClasses = {};
      var className = (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])(_classNames, classes.fullScreenVariant, variant === 'fullscreen'), (0, _defineProperty2["default"])(_classNames, classes.wizardVariant, variant === 'wizard'), (0, _defineProperty2["default"])(_classNames, classes.pageVariant, variant === 'page'), _classNames));

      if (['wizard', 'page'].indexOf(variant) !== -1) {
        snackBarClasses.root = classes.wizardOrPageSnackbar;
      }

      return _react["default"].createElement("div", {
        className: className
      }, this.props.children);
    }
  }]);
  return NotificationBar;
}(_react.PureComponent);

NotificationBar.propTypes = {
  variant: _propTypes["default"].oneOf(['fullscreen', 'wizard', 'page']).isRequired,
  children: _propTypes["default"].node,
  classes: _propTypes["default"].object
};
NotificationBar.defaultProps = {
  variant: 'fullscreen'
};

var _default = (0, _styles.withStyles)(styles)(NotificationBar);

exports["default"] = _default;